module.exports = __webpack_public_path__ + "img/clienti7.60ed0076.png";